import { postRequest, trustedRequest, putRequest } from 'utils/request';

export const login = postRequest('/api/login');

export const checkLogin = () => trustedRequest('/api/login/status');

export const logout = () => trustedRequest('/api/logout');

export const changePassword = (values: { new_password: string, old_password: string }) => putRequest('/api/passChange')(values);

export const restorePassword = postRequest('/api/restore');